import type { CategorySlug } from 'src/common/boatCategories';

const nonCaptainableCategories: CategorySlug[] = [
  'diving',
  'flyboarding',
  'jet-ski-rental',
  'kayak-rentals',
  'kiteboarding',
  'paddle-sports',
  'paddleboard-rentals',
  'parasailing',
  'rafting',
  'snorkeling',
  'wakeboarding',
  'water-skiing',
  'windsurfing',
];

export default nonCaptainableCategories;
